import {mapState} from "vuex";

export default {
    data: function() {
      return {
        currency_symbols:{
            'USD': '$', // US Dollar
            'EUR': '€', // Euro
            'CRC': '₡', // Costa Rican Colón
            'GBP': '£', // British Pound Sterling
            'ILS': '₪', // Israeli New Sheqel
            'INR': '₹', // Indian Rupee
            'JPY': '¥', // Japanese Yen
            'KRW': '₩', // South Korean Won
            'NGN': '₦', // Nigerian Naira
            'PHP': '₱', // Philippine Peso
            'PLN': 'zł', // Polish Zloty
            'PYG': '₲', // Paraguayan Guarani
            'THB': '฿', // Thai Baht
            'UAH': '₴', // Ukrainian Hryvnia
            'VND': '₫', // Vietnamese Dong
        }
      };
    },
    methods: {
    },
    computed: {
        ...mapState(["client"]),
        currency_symbol() {
            const key = this.client.SquareCurrencyCode
            if (!key) {return "$"}
            return this.currency_symbols[key] ? this.currency_symbols[key] : "$"
        }
    }
  };
  